import { Controller } from 'stimulus';

class HeaderController extends Controller {
  connect() {
    this.isFixed = false;

    this.checkHeaderOffsetAndScroll = () => {
      this.checkHeaderOffset();
      this.onWindowScroll();
    };

    window.addEventListener('scroll', this.onWindowScroll.bind(this));
  }

  disconnect() {
    window.removeEventListener('scroll', this.onWindowScroll.bind(this));
  }

  onWindowScroll() {
    const top = window.scrollY;

    if (top >= 0 && !this.isFixed) {
      this.isFixed = true;
      this.setFixedState();
    } else if (top <= 0 && this.isFixed) {
      this.isFixed = false;
      this.setFixedState();
    }
  }

  setFixedState() {
    this.element.classList[this.isFixed ? 'add' : 'remove']('is-fixed');
  }
}

HeaderController.targets = [
  //
];

export default HeaderController;
